var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _vm.setUp === null
        ? _c("gg-loading", {
            attrs: {
              loading: true,
              type: "card"
            }
          })
        : !_vm.setUp
        ? _c("feature-setup", {
            attrs: {
              feature: "filters"
            },
            on: {
              create: function create($event) {
                _vm.creating = true
              }
            }
          })
        : _c(
            "gg-card",
            [
              _c("gg-card-header", [
                _c(
                  "div",
                  {
                    staticClass: "d-flex align-center flex-wrap"
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "mr-auto"
                      },
                      [_vm._v("Filters by Users")]
                    ),
                    _c(
                      "gg-btn",
                      {
                        staticClass: "my-1",
                        attrs: {
                          secondary: "",
                          small: ""
                        },
                        on: {
                          click: function click($event) {
                            _vm.creating = true
                          }
                        }
                      },
                      [
                        _c(
                          "v-icon",
                          {
                            attrs: {
                              left: "",
                              small: ""
                            }
                          },
                          [_vm._v("mdi-plus")]
                        ),
                        _vm._v("Create Filter ")
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c(
                "gg-card-text",
                [
                  _c("filters-table", {
                    attrs: {
                      "manage-to": _vm.manageTo
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
      _c("create-filter-modal", {
        attrs: {
          "is-active": _vm.creating,
          service: _vm.service,
          "scope-domain": _vm.$route.params.maindomain
        },
        on: {
          created: _vm.onCreated,
          close: function close($event) {
            _vm.creating = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }